'use client';

import NextLink from 'next/link';
import type { ComponentProps } from 'react';
import NavigationProgress from './NavigationProgress';

type AppLinkProps = ComponentProps<typeof NextLink>;

export default function AppLink({ children, prefetch, ...props }: AppLinkProps) {
  return (
    <NextLink {...props} prefetch={prefetch}>
      {children}
      <NavigationProgress />
    </NextLink>
  );
}
